import React from 'react'
import {
  CodeBracketSquareIcon,
  InboxStackIcon,
} from '@heroicons/react/24/solid'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'
import ToolCard from '../../../Components/ToolCard'

const ListingsToolsView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Listings"
        title="Listings tools"
        subtitle="Monitor Amazon cases and run brand web scrapers."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Listings' },
        ]}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <ToolCard
          title="Amazon Cases"
          description="Track case status and conversation threads for Amazon listings."
          icon={InboxStackIcon}
          to="/listings-tool/amazon_cases"
          badge="Active"
        />
        <ToolCard
          title="Web Scrapers"
          description="Launch brand scrapers and download request outputs."
          icon={CodeBracketSquareIcon}
          to="/listings-tool/web_scrapers"
          badge="Active"
        />
      </div>
    </AppShell>
  )
}

export default ListingsToolsView
